import script from "./CalendarioDeAtividades.vue?vue&type=script&lang=ts&setup=true"
export * from "./CalendarioDeAtividades.vue?vue&type=script&lang=ts&setup=true"

import "./CalendarioDeAtividades.vue?vue&type=style&index=0&id=56b7f96b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56b7f96b"]])

export default __exports__